import { Card, CardContent } from "./ui/card";

/**
 * SoulWeather — a single horoscope-style pill that replaces the dense numeric
 * stat cards (1 Meal / 2 Glasses / 3 Journal / …) with a poetic read on how
 * the user's soul "feels" today, calculated server-side from recent rituals,
 * streak, and most-recent mood.
 *
 * Shape of `weather` (from /api/weekly-summary.soul_weather):
 *   { anchor: {emoji,label}, energy: {emoji,label}, flow: {emoji,label}, narrative }
 */
const SoulWeather = ({ weather }) => {
  if (!weather) {
    return (
      <div className="rounded-2xl bg-primary/5 border border-border/40 px-5 py-4 animate-pulse">
        <div className="h-4 w-32 bg-muted/50 rounded mb-2" />
        <div className="h-6 w-64 bg-muted/40 rounded" />
      </div>
    );
  }

  const { anchor, energy, flow, narrative } = weather;

  return (
    <Card
      className="bg-gradient-to-br from-emerald-500/5 via-teal-500/5 to-sky-500/5 border-emerald-500/20 animate-fade-in overflow-hidden"
      data-testid="soul-weather-card"
    >
      <CardContent className="p-4 md:p-5">
        <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mb-2">
          Soul Weather
        </p>
        <div className="flex items-center gap-2 md:gap-3 flex-wrap">
          {[anchor, energy, flow].map((d, idx) => (
            <span
              key={idx}
              className="inline-flex items-center gap-1.5 bg-background/70 backdrop-blur-sm border border-border/40 rounded-full px-3 py-1.5 text-sm font-medium text-primary soul-weather-pill"
              style={{ animationDelay: `${idx * 1.3}s` }}
              data-testid={`soul-weather-pill-${idx}`}
            >
              <span className="text-base soul-weather-emoji" aria-hidden="true" style={{ animationDelay: `${idx * 1.3}s` }}>{d.emoji}</span>
              <span>{d.label}</span>
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs text-muted-foreground italic leading-relaxed">
          {narrative}
        </p>
      </CardContent>
    </Card>
  );
};

export default SoulWeather;
